import { formComponent } from "../datasets/formComponent";

const flattenDataArray = data => {
  let newData = { fields: [] };
  data.fields.forEach(field => {
    if (field.component !== "standard-multielement") {
      newData.fields.push(field);
    } else {
      newData.fields.push(...field.fields);
    }
  });

  return newData;
};

export const validate = ({ type, formData, data, changeErrors, consent }) => {
  const newErrors = setErrors({ type, formData, data: flattenDataArray(data), consent });
  changeErrors(newErrors);
  if (Object.keys(newErrors).length === 0) {
    return true;
  } else {
    scrollToError(newErrors);
    return false;
  }
};

const setErrors = ({ type, formData, data, consent }) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let newErrors = {};
  if (
    type === "DSAR" &&
    formData.is_data_subject !==
      data.fields.filter(field => field.id === "is_data_subject")[0].options[1]
  ) {
    data.fields
      .filter(
        field => field.required === true && field.id.substring(0, 8).indexOf("detail_") === -1,
      )
      .forEach(field => {
        if (formData[field.id].length === 0)
          newErrors[field.id] = formComponent.errors.field_required;
        if (formData.email.length !== 0 && !regex.test(String(formData.email).toLowerCase()))
          newErrors.email = formComponent.errors.incorrect_mail;
      });
  } else {
    data.fields
      .filter(field => field.required === true)
      .forEach(field => {
        if (formData[field.id].length === 0)
          newErrors[field.id] = formComponent.errors.field_required;
        if (
          typeof formData.email !== "undefined" &&
          formData.email?.length !== 0 &&
          !regex.test(String(formData.email).toLowerCase())
        )
          newErrors.email = formComponent.errors.incorrect_mail;
        if (
          typeof formData.email_bottom !== "undefined" &&
          formData.email_bottom?.length !== 0 &&
          !regex.test(String(formData.email_bottom).toLowerCase())
        )
          newErrors.email_bottom = formComponent.errors.incorrect_mail;
      });
  }
  if (typeof consent !== "undefined" && consent === false)
    newErrors.consent = formComponent.errors.field_required;

  return newErrors;
};

const scrollToError = errorsObject => {
  let errorLabels = [];
  errorLabels = Object.keys(errorsObject);
  let scrollTop = window.pageYOffset;
  let positions = [];
  errorLabels.forEach(label => {
    let element = document.getElementById(`standard-${label}`);
    if (typeof element === "undefined") element = document.getElementById(`retractible-${label}`);
    if (label === "consent") element = document.getElementById("consent");
    let rect = element.getBoundingClientRect();
    let position = rect.top;
    positions.push(position);
  });
  window.scroll({
    top: Math.min(...positions) + scrollTop - 170,
    left: 0,
    behavior: "smooth",
  });
};
